//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Mechatronics.js";
import "../no/Builder.js";
let d=[[[0,"FlagOfUsingContainer",1,0],[0,"FlagOfUsingSpecifiedMCF",1,0],[0,"Name",1,0],[0,"SpecifiedMCF",1,0]],[[["ncFile"],"LoadNCFile",{},1,0],[["ncCodeLines"],"UpdateNCCode",{},1,0],[["ncFile"],"ExportNCCode",{},1,0],[["isRunningOK","errMsg","lineNum","ncLine"],"RunCSE",{},0,0],[["numAxis","axisNames","numMachineEvent","machineEventNames"],"GetAxesAndMachineEvents",{},0,0],[["isAxis","axisOrEventName"],"GetMCDConnection",{R_:{mcdConnectedTag:"TaggedObject"}},2,0],[["isAxis","axisOrEventName","mcdConnectedTag"],"SetMCDConnection",{},3,0],[["axisName"],"GetAxisType",{R_:{axisType:''}},1,0],[["axisName","axisType"],"SetAxisType",{},2,0]],[]];
SPLM.Mechatronics.RuntimeNCBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Mechatronics.RuntimeNCBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Mechatronics.RuntimeNCBuilder.AxisTypes = Object.freeze({
    "Invalid" : "Invalid", "Linear" : "Linear", "Rotary" : "Rotary"});

export default SPLM;